type TabContentProps = {
    children: React.ReactNode
}

const TabContent = (props: TabContentProps) => {
    const { children } = props

    return <div className="px-8 py-6 flex-1 h-full overflow-y-scroll">{children}</div>
}

export default TabContent
